import { RoundOff } from "../types/retailShop";

export function roundAmt(number: number, roundOff?: RoundOff): number {
  if (!roundOff) return number;

  switch (roundOff) {
    case "roundUp":
      return Math.ceil(number);
    case "roundDown":
      return Math.floor(number);
    case "toSignificant":
      return Math.round(number);
    case "roundUp1":
      return roundUpToDecimal(number, 1);
    case "roundDown1":
      return roundDownToDecimal(number, 1);
    case "roundHalf1":
      return parseFloat(number.toFixed(1));
    case "roundUp2":
      return roundUpToDecimal(number, 2);
    case "roundDown2":
      return roundDownToDecimal(number, 2);
    case "toFixed":
      return parseFloat(number.toFixed(2));
    default:
      return number;
  }
}

function roundDownToDecimal(number: number, decimalPlaces: number): number {
  const factor = 10 ** decimalPlaces;
  return Math.floor(number * factor) / factor;
}

function roundUpToDecimal(number: number, decimalPlaces: number): number {
  const factor = 10 ** decimalPlaces;
  return Math.ceil(number * factor) / factor;
}
